namespace TabAurous.Inventory {
    export interface SKUGenerationForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherTypeId: Serenity.StringEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        Details: SKUStockItemEditor;
        Pieces: Serenity.IntegerEditor;
        NoofSKU: Serenity.IntegerEditor;
        Markup: Serenity.DecimalEditor;
        GenerateSKU: ButtonEditor;
        PrintingDetails: SKUPrintingEditor;
        UserId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        SKUSelected: Serenity.StringEditor;
        LineNoSelected: Serenity.StringEditor;
        ProductIdSelected: Serenity.StringEditor;
        AttributeIdSelected: Serenity.StringEditor;
    }

    export class SKUGenerationForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKUGeneration';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUGenerationForm.init)  {
                SKUGenerationForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;
                var w4 = SKUStockItemEditor;
                var w5 = s.IntegerEditor;
                var w6 = s.DecimalEditor;
                var w7 = ButtonEditor;
                var w8 = SKUPrintingEditor;

                Q.initFormType(SKUGenerationForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'VoucherTypeId', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w2,
                    'Details', w4,
                    'Pieces', w5,
                    'NoofSKU', w5,
                    'Markup', w6,
                    'GenerateSKU', w7,
                    'PrintingDetails', w8,
                    'UserId', w5,
                    'EmployeeId', w5,
                    'CompanyId', w5,
                    'FinancialYearId', w5,
                    'SKUSelected', w2,
                    'LineNoSelected', w2,
                    'ProductIdSelected', w2,
                    'AttributeIdSelected', w2
                ]);
            }
        }
    }
}
